import React from 'react';
import AppleMusicIcon from './AppleMusicIcon';
import SpotifyLogo from './SpotifyLogo';

/**
 * Renders already-ordered music links (see utils/musicService.js) as a flat
 * list of anchors — no wrapper element, so each surface keeps its own
 * container and spacing. Class names are derived from `classPrefix`
 * (`item-card` -> `item-card-apple-music`, `item-card-spotify`,
 * `item-card-music-other`).
 *
 * Apple and Spotify keep their branded marks; every other source renders as
 * a plain text link, deliberately not a lockup with either of them.
 */
export default function MusicLinks({
  links,
  classPrefix,
  subject,
  stopPropagation = false,
}) {
  if (!links.length) return null;

  const onClick = stopPropagation ? (e) => e.stopPropagation() : undefined;
  const describe = (label) => (subject ? `Listen to ${subject} on ${label}` : `Open in ${label}`);

  return links.map(({ provider, label, url }) => (
    <a
      key={provider}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={
        provider === 'apple'
          ? `${classPrefix}-apple-music`
          : provider === 'spotify'
          ? `${classPrefix}-spotify`
          : `${classPrefix}-music-other`
      }
      aria-label={describe(label)}
      title={describe(label)}
      onClick={onClick}
    >
      {provider === 'apple' ? (
        <AppleMusicIcon />
      ) : provider === 'spotify' ? (
        <SpotifyLogo />
      ) : (
        label
      )}
    </a>
  ));
}
